import React, { useEffect, useState } from "react";
import { status_dictionary } from "common/helpers/statusHelper";
import { Button } from "react-bootstrap";
import Modal from 'react-bootstrap/Modal';
import styles from './InventoryItem.module.scss'
import Axios from 'services/BackendApi/BackendApi';
import { isDisabled } from "@testing-library/user-event/dist/utils";
import GlifosDigitalArchiveViewer from 'modules/catalog/components/GlifosDigitalArchiveViewer/GlifosDigitalArchiveViewer'

const itemDownload = async (record, item, file) => {
  window.open(file, "_blank");
};

const InventoryItem = (props) => {
  const { item, record } = props;
  const id = item;
  const [location, setLocation] = useState();
  const [count, setCount] = useState();
  const [doc, setDoc] = useState();
  const [bookedBy, setBookedBy] = useState();
  const [status, setStatus] = useState();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [showMini, setShowMini] = useState(false);
  const bearer = localStorage.getItem("userInfo");
  const token = JSON.parse(bearer).access_token;
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [texto, setTexto] = useState("Ver Documento");

  useEffect(() => {
    getData()
    if (record) {
      if (record?.fileid == undefined) {
        setDeshabilitado(true)
        setTexto("No tiene Documento")
      }
    }
  }, [])

  const handleShow = () => {
    setShow(true);
  };

  const handleCloseMini = () => setShowMini(false);

  const handleShowMini = () => {
    setShowMini(true);
  };


  async function getData() {
    let res = await Axios.GetLocation({ urlParams: { id: item } });
    console.log(res.data)
    setLocation(res.data.response);
    setCount(res.data.count);
    let doctype = await Axios.GetOneDocType({ urlParams: { id: record?.hierarchy[3]?.value } });
    setDoc(doctype.data);
    let status = await Axios.GetBookedStatus({ urlParams: { id: item } });
    console.log(status)
    setBookedBy(status.data.name);
    setStatus(status.data.status);
  }

  async function Reservar() {
    await Axios.Booked({ urlParams: { id: item } });
    setShow(false);
    window.location.reload(false);
    // let doctype = await Axios.GetOneDocType({ urlParams: { id: record?.hierarchy[3]?.value } });
    // setDoc(doctype.data);
  }
  function disableUpdate() {
    if (bookedBy == null) {
      return false;
    } else {
      return true;
    }

  }

  const [items, setItems] = useState([]);

  useEffect(() => {
    const storedItems = localStorage.getItem('items');
    console.log(storedItems)

    if (storedItems) {
      setItems(JSON.parse(storedItems));
    }
  }, []);
  
  // useEffect(() => {
  //   console.log(items)
  //   localStorage.setItem('items', JSON.stringify(items));
  // }, [items]);


  // async function addDossier () {
  //   // console.log(id)
  //   let doc = await Axios.GetNodeForDossier({ urlParams: {id} });
  //   if (items.some(item => item.id === doc.data.id)) {
  //     const updatedItems= items.filter(item => item.id !== doc.data.id);
  //     setItems(updatedItems);
  //   } else {
  //     setItems([...items, doc.data]);
  //   }
  // };


  return (
    <>
      {(count == 2 ? <div className="card mb-2">
        <div className="card-header">
          <div className="d-flex flex-row justify-content-between">
            <div>
              <b>Item:</b> {item}
            </div>
            <h5>
              <span
                className={(bookedBy == null) ? `badge ${status_dictionary[item?.status]?.cssClass || "bg-success"}` :
                  `badge ${status_dictionary[item?.status]?.cssClass || "bg-secondary"}`}>
                {(bookedBy == null) ? "Disponible" : (status === 1) ? "Reservado" : (status === 5) ? "En Carrito" : "No disponible"}
              </span>
            </h5>
          </div>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-12 col-lg-10 mb-2">
              {/* {item?.bookin && item?.bookin !== "null" && ( */}
              {(status == 2) ?
                <div>
                  <b>Prestado a: </b>
                  {bookedBy}
                </div>
                : ""}
              {/* )} */}
              {/* {item?.location && item?.location !== "null" && ( */}
              <div>
                <b>Ubicación: </b>
                {location}
                {/* {item?.location} */}
              </div>
              {/* )} */}
              {/* {item?.circulation_type && item?.circulation_type !== "null" && ( */}
              <div>
                <b>Circulación: </b>
                Normal de unidad documental (3-15 dias)
                {/* {item?.circulation_type} */}
              </div>
              {/* )} */}
              {/* {item?.material_type && item?.material_type !== "null" && ( */}
              <div>
                <b>Tipo de documento: </b>
                {doc}
                {/* {item?.material_type} */}
              </div>
              <span className="me-2">
                <i className="fas fa-globe-americas"></i>
              </span>
            </div>
            <div className="col-12 col-lg-2 d-flex flex-column justify-content-center">
              <Button variant="warning" onClick={() => Reservar()} disabled={disableUpdate()}>Agregar al carrito</Button>
            </div>
          </div>
        </div>
      </div> : null)}
      <div className="card mb-2">
        <div className="card-header">
          <div className="d-flex flex-row justify-content-between">
            <div>
              <b>Item:</b> {item}
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-12 col-lg-10 mb-2">
              {/* {item?.location && item?.location !== "null" && ( */}
              <div>
                <b>Ubicación: </b>
                Documento Electrónico
                {/* {item?.location} */}
              </div>
              {/* )} */}
              {/* {item?.circulation_type && item?.circulation_type !== "null" && ( */}
              {/* )} */}
              {/* {item?.material_type && item?.material_type !== "null" && ( */}
              <div>
                <b>Tipo de documento: </b>
                {doc}
                {/* {item?.material_type} */}
              </div>
              <span className="me-2">
                <i className="fas fa-globe-americas"></i>
              </span>
            </div>
            <div className="col-12 col-lg-2 d-flex flex-column justify-content-center">
            {(!deshabilitado) ?
                  <Button className={styles.boton} onClick={() => handleShowMini()}>{texto}</Button>
                  :
                  null
                }
            </div>
          </div>
        </div>
      </div>
      <Modal show={showMini} fullscreen={true} className={styles.modal} onHide={handleCloseMini}>
        <Modal.Header closeButton>
          <Modal.Title>{item}</Modal.Title>
        </Modal.Header>
        <Modal.Body className={styles.columna}>
          <GlifosDigitalArchiveViewer src={"/api/v1/file/get-file/" + record?.fileid} token={token} />
        </Modal.Body>
        <Modal.Footer>
        {/* <Button onClick={()=>addDossier(record)} variant={( items.some(item => item.id === nodo) == true)?"danger":"warning"}>{( items.some(item => item.id === nodo) == true)?"Eliminar de Expediente":"Agregar a expediente"}</Button> */}

        </Modal.Footer>
      </Modal>
      <Modal backdrop="static" keyboard={false} show={show} onHide={handleClose} dialogClassName={styles.alerta}>
        <Modal.Header className={styles.header}>
          <Modal.Title style={{ color: 'white' }} >Confirmación</Modal.Title>
        </Modal.Header>
        <Modal.Body className={styles.columna}>
          <div>
          </div>
          <div className={styles.buttons}>
            <h5>
              Esta seguro que desea reservar este documento?
            </h5>
            <Button className={styles.btn} onClick={() => Reservar()}>Si</Button>
            <Button className={styles.btn} variant="danger" onClick={handleClose}>No</Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default InventoryItem;
